var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPriceTagTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.071,
    height: 20.498,
    viewBox: "0 0 10.071 20.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price_Tag_Tip_-_small",
    "data-name": "Price Tag Tip - small",
    transform: "translate(-135.633 -320.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163313",
    "data-name": "Path 163313",
    d: "M136.855,333.083,144.509,341h1.012V321h-1.012l-7.654,7.914A3.075,3.075,0,0,0,136.855,333.083Zm4.431-4.169a2.094,2.094,0,0,1,0,4.183,2.092,2.092,0,0,1,0-4.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163314",
    "data-name": "Path 163314",
    d: "M145.453,321H144.5l-7.651,7.914a3.006,3.006,0,0,0,0,4.169C138.755,335.371,144.5,341,144.5,341h.954",
    fill: "none",
    stroke: "#b1b3b3",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    transform: "translate(138.971 328.751)",
    fill: "none",
    stroke: "#b1b3b3",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPriceTagTip);
export default __webpack_public_path__ + "static/media/small-price-tag-tip.57a4d1d5373128592100f71245ca53a9.svg";
export { ForwardRef as ReactComponent };